module.exports = __webpack_public_path__ + "img/banner_RSV_bg_yd.112252a1.webp";